import { createFileRoute } from '@tanstack/react-router';
import { CoverageDashboard } from '@/features/qa/CoverageDashboard';

/** Cruscotto della copertura: su tutte le campagne insieme, oppure su una sola. */
export const Route = createFileRoute('/_app/test-coverage')({ component: CoverageDashboard });
